angular
	.module 'App.Directive'
	.directive 'formActionButtons', ->
		restrict: 'AE'
		scope:
			form: '='
			saving: '=?'
			isNewEntity: '=?'
			entityType: '=?'
			showDelete: '=?'
			showSave: '=?'
			deletionAlertText: '=?'
			additionalButtons: '=?'
		templateUrl: '@directive/form/form-action-buttons/form-action-buttons.view.html'
		controller: 'FormActionButtonsController'
		controllerAs: 'formActionButtons'
		bindToController: true

class FormActionButtonsController extends BaseController
	@register angular.module 'App.Directive'
	@inject '$rootScope',
		'MessageTerminal'

	autoScopeInject: false

	initialize: ->
		@showDelete ?= true
		@showSave ?= true
		@saving ?= false
		@isNewEntity ?= false
		@deletionAlertText ?= null

	save: ->
		@MessageTerminal.publish @MessageTerminal.events.CRUD.SAVE

	remove: ->
		@MessageTerminal.publish @MessageTerminal.events.CRUD.DELETE
